module.exports = __webpack_public_path__ + "img/yml_gallery11.3812d4a2.jpg";